import { request } from './client';

export interface ShareLink {
  id: string;
  slug: string;
  permission: string;
  passwordHash?: string;
  expiresAt: string | null;
  url: string;
  createdAt: string;
}

export interface CreateShareLinkParams {
  permission: 'view' | 'comment' | 'edit';
  password?: string;
  expiresAt?: string;
}

export const shareLinksApi = {
  list: (wsId: string, docId: string) =>
    request<ShareLink[]>(`/share-links/workspaces/${wsId}/docs/${docId}`),

  create: (wsId: string, docId: string, data: CreateShareLinkParams) =>
    request<ShareLink>(`/share-links/workspaces/${wsId}/docs/${docId}`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  revoke: (wsId: string, linkId: string) =>
    request<{ ok: boolean }>(`/share-links/workspaces/${wsId}/${linkId}`, {
      method: 'DELETE',
    }),
};